<div class="data-filters-group" [ngClass]="{ 'space-between': spaceBetween, 'use-available-width': useAvailableWidth }">
    <ng-content select="app-data-filter-group, app-data-filter-input, app-data-filter-select, app-data-filter-datepicker"></ng-content>
</div>